/* Home hero carousel - 2 November 2026.
 *
 * Deliberately small. The scrolling, snapping, momentum and keyboard support
 * are the browser's; this file only reports which slide is in front and moves
 * the track when an arrow or a dot is pressed.
 *
 * NOTHING HERE LISTENS ON window, and the one scroll listener is passive and
 * on the track. CLAUDE.md: a single non-passive wheel/touchmove listener on
 * window disables compositor scrolling for the whole page, and that is the
 * biggest reason this site's scrolling once read as unnatural on a phone.
 */
(function () {
  var root = document.querySelector('[data-cc-hero-carousel]');
  if (!root) return;
  root.classList.remove('cc-hcar--nojs');

  var track = root.querySelector('[data-hcar-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('.cc-hcar__slide'));
  var prev = root.querySelector('[data-hcar-prev]');
  var next = root.querySelector('[data-hcar-next]');
  var nameEl = root.querySelector('[data-hcar-name]');
  var countEl = root.querySelector('[data-hcar-count]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hcar-dot]'));
  var useEl = root.querySelector('[data-hcar-use]');
  if (!track || !slides.length) return;

  var current = 0;

  function paint(i) {
    current = i;
    if (nameEl) nameEl.textContent = slides[i].getAttribute('data-name') || '';
    if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
    for (var d = 0; d < dots.length; d++) {
      dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
    }
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
    /* The named control carries the slide in front. Same href and the same
       data-cc-setstart the photograph has, so cc-diy-page.js handles both
       through one listener and there is no second way in to keep right.
       A slide with no set id leaves it hidden rather than pointing nowhere. */
    if (useEl) {
      var id = slides[i].getAttribute('data-set-id');
      if (id) {
        useEl.setAttribute('data-cc-setstart', id);
        useEl.hidden = false;
      } else {
        useEl.removeAttribute('data-cc-setstart');
        useEl.hidden = true;
      }
    }
    /* Only the slide in front is reachable by tab or a screen reader; the
       others are off-screen and would otherwise be read as part of the page. */
    for (var s = 0; s < slides.length; s++) {
      if (s === i) slides[s].removeAttribute('inert');
      else slides[s].setAttribute('inert', '');
    }
  }

  /* Which slide is in front, from geometry rather than a scroll-position
     calculation, so it stays right if a slide ever changes width. */
  function nearest() {
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0, bestD = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var c = slides[i].offsetLeft + slides[i].offsetWidth / 2;
      var d = Math.abs(c - mid);
      if (d < bestD) { bestD = d; best = i; }
    }
    return best;
  }

  var tick = null;
  track.addEventListener('scroll', function () {
    if (tick) return;
    tick = requestAnimationFrame(function () {
      tick = null;
      var i = nearest();
      if (i !== current) paint(i);
    });
  }, { passive: true });

  function go(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
  }

  if (prev) prev.addEventListener('click', function () { go(current - 1); });
  if (next) next.addEventListener('click', function () { go(current + 1); });
  for (var d = 0; d < dots.length; d++) {
    (function (i) {
      dots[i].addEventListener('click', function () { go(i); });
    })(d);
  }

  paint(0);
})();
